import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import { vdCompanyApi } from '../api';

export default function VDCompanySetup() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { register, handleSubmit, reset, watch, setValue } = useForm();
  const afterHoursEnabled = watch('afterHoursEnabled');

  useEffect(() => {
    vdCompanyApi.get().then(d => { reset(d); setLoading(false); });
  }, [reset]);

  const onSubmit = async (data) => {
    setSaving(true);
    await vdCompanyApi.update(data);
    toast.success('Company settings saved');
    setSaving(false);
  };

  if (loading) return <div className="animate-pulse h-96 bg-card/5 rounded-xl" />;

  return (
    <div className="max-w-2xl space-y-6" data-testid="vd-company-setup">
      <div>
        <h1 className="text-2xl font-bold">Company Setup</h1>
        <p className="text-muted-foreground text-sm mt-1">Configure your business information</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <Card className="bg-card/5 border-white/10">
          <CardHeader><CardTitle className="text-base">Business Info</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div><Label>Company Name</Label><Input {...register('companyName')} className="bg-card/5 border-white/10 mt-1" placeholder="Acme Corp" /></div>
              <div><Label>Business Phone</Label><Input {...register('businessPhone')} className="bg-card/5 border-white/10 mt-1" placeholder="+1 (555) 000-0000" /></div>
              <div><Label>Business Type</Label><Input {...register('businessType')} className="bg-card/5 border-white/10 mt-1" placeholder="e.g. Dental, Legal, HVAC" /></div>
              <div><Label>Timezone</Label><Input {...register('timezone')} className="bg-card/5 border-white/10 mt-1" placeholder="America/Los_Angeles" /></div>
            </div>
            <div><Label>Fallback Number</Label><Input {...register('fallbackNumber')} className="bg-card/5 border-white/10 mt-1" placeholder="Operator / main line" /></div>
          </CardContent>
        </Card>

        <Card className="bg-card/5 border-white/10">
          <CardHeader><CardTitle className="text-base">Greeting & After Hours</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div><Label>Company Greeting</Label><Textarea {...register('greeting')} className="bg-card/5 border-white/10 mt-1" rows={3} placeholder="Thank you for calling..." /></div>
            <div className="flex items-center justify-between">
              <Label>After-Hours Handling</Label>
              <Switch checked={!!afterHoursEnabled} onCheckedChange={v => setValue('afterHoursEnabled', v)} />
            </div>
            {afterHoursEnabled && (
              <>
                <div><Label>After-Hours Message</Label><Textarea {...register('afterHoursMessage')} className="bg-card/5 border-white/10 mt-1" rows={2} /></div>
                <div><Label>After-Hours Forward To</Label><Input {...register('afterHoursRoute')} className="bg-card/5 border-white/10 mt-1" placeholder="Phone number or voicemail" /></div>
              </>
            )}
          </CardContent>
        </Card>

        <Button type="submit" disabled={saving} className="bg-emerald-500 hover:bg-emerald-600 text-black font-medium">
          {saving ? 'Saving...' : 'Save Settings'}
        </Button>
      </form>
    </div>
  );
}
